import TotalByProperty from "./TotalByProperty";

export default TotalByProperty;
